/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import { Card, CardContent, Typography, Grid, Tooltip } from '@mui/material'
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows'
import CallIcon from '@mui/icons-material/Call'
import PersonIcon from '@mui/icons-material/Person'

export default function StationCardMonitor({ station, user, stationIsOnline }) {
  return (
    <Card variant="outlined" sx={{ cursor: 'move', userSelect: 'none' }}>
      <CardContent sx={{ pointerEvents: 'none' }}>
        <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
          <Grid xs={3} sx={{ alignItems: 'center', textAlign: 'center' }}>
            <DesktopWindowsIcon
              fontSize={'large'}
              sx={{ color: stationIsOnline ? 'green' : 'red' }}
            />
            <Typography>{stationIsOnline ? 'ON' : 'OFF'}</Typography>
          </Grid>
          <Grid xs={9} sx={{ alignItems: 'center' }}>
            
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
              }}
            >
              <DesktopWindowsIcon fontSize={'small'} />{' '}
              <Tooltip title={station?.name || 'Não Informado'} disableInteractive>
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {station?.name || 'Não Informado'}
                </span>
              </Tooltip>
            </Typography>
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
              }}
            >
              <PersonIcon fontSize={'small'} />{' '}
              <Tooltip title={user?.representation_name || 'Não Informado'} disableInteractive>
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {user?.representation_name || 'Não Informado'}
                </span>
              </Tooltip>
            </Typography>
            <Typography>
              <CallIcon fontSize={'small'} />{' '}
              {station?.branch_line ? station?.branch_line : 'Não Informado'}
            </Typography>
            {/* <Typography>
              Status: PM2023565162 [Aberto]
            </Typography> */}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
